var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8 4H5.2C4.8 4 4.5 4.3 4.5 4.7V19.4C4.5 19.7 4.8 20 5.2 20H19.9C20.3 20 20.6 19.7 20.6 19.3V4.7C20.5 4.3 20.2 4 19.8 4ZM9.2 17.6H6.9V10H9.3V17.6H9.2ZM8.1 9C7.3 9 6.7 8.3 6.7 7.6C6.7 6.8 7.3 6.2 8.1 6.2C8.9 6.2 9.5 6.8 9.5 7.6C9.4 8.3 8.8 9 8.1 9ZM18.1 17.6H15.7V13.9C15.7 13 15.7 11.9 14.5 11.9C13.3 11.9 13.1 12.9 13.1 13.9V17.7H10.7V10H13V11C13.3 10.4 14.1 9.8 15.2 9.8C17.6 9.8 18 11.4 18 13.4V17.6H18.1Z",
    fill: "#0BA9F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.b46f207140ec803ca6f19761020d3a14.svg";
export { ForwardRef as ReactComponent };